export const FILTER_BAR = "FILTER_BAR";
export const OVERVIEW = "OVERVIEW";
export const MENUS = "MENUS";
export const LOADER = "LOADER";
export const FOOD_MENUS = "FOOD_MENUS";

// export const RESTAURANT_SEARCH = "RESTAURANT_SEARCH";
